import { render, staticRenderFns } from "./LawMatterTypeList.vue?vue&type=template&id=02451ad3&"
import script from "./LawMatterTypeList.vue?vue&type=script&lang=js&"
export * from "./LawMatterTypeList.vue?vue&type=script&lang=js&"
import style0 from "./LawMatterTypeList.vue?vue&type=style&index=0&id=02451ad3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports